/** Confirmation de suppression de compte : action IRRÉVERSIBLE, protégée par la
 * saisie du mot « SUPPRIMER ». Réutilise Modal (a11y) + useSubmit (pending/erreur). */
import { useState } from 'react';
import { useSubmit } from '@/hooks/useSubmit';
import { useAuth } from '@/lib/auth';
import { Modal } from './Modal';
import { ErrorBanner } from './ui';

const CONFIRM_WORD = 'SUPPRIMER';

export function DeleteAccountModal({ onClose }: { onClose: () => void }) {
  const { deleteAccount } = useAuth();
  const submit = useSubmit();
  const [confirmText, setConfirmText] = useState('');

  // Sensible à la casse : le mot doit être tapé exactement.
  const canDelete = confirmText.trim() === CONFIRM_WORD && !submit.pending;

  function confirm() {
    // Succès → l'app redirige vers /login (authStore vidé) et la modale démonte seule.
    // Échec → useSubmit expose l'erreur, la modale reste ouverte.
    void submit.run(() => deleteAccount());
  }

  return (
    <Modal title="Supprimer le compte" onClose={onClose}>
      <p style={{ marginTop: 0 }}>
        Cette action est <strong>définitive</strong>. Toutes tes données (poids, calories,
        hydratation, séances, aliments personnels, favoris…) seront effacées et irrécupérables.
      </p>
      <div className="field">
        <label htmlFor="confirm-delete">
          Tape <strong>{CONFIRM_WORD}</strong> pour confirmer
        </label>
        <input
          id="confirm-delete"
          type="text"
          autoComplete="off"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
        />
      </div>
      {submit.error && (
        <ErrorBanner message="Suppression impossible. Réessaie." onRetry={submit.reset} />
      )}
      <div className="toolbar" style={{ margin: 0 }}>
        <button type="button" className="danger" disabled={!canDelete} onClick={confirm}>
          {submit.pending ? 'Suppression…' : 'Supprimer définitivement'}
        </button>
        <button type="button" className="ghost" onClick={onClose}>
          Annuler
        </button>
      </div>
    </Modal>
  );
}
